import * as types from '../eventsActions';
import * as transformers from '../transformer';
import { analyticsListNames } from '../constant';
import { paymentMethodMap } from '../constant';

const initialState = {
  listName: '',
  model: '',
  impressionSent: false,
  activeDiagram: -1,
  lastActiveDiagram: -1,
  diagramAndImpression: {},
  paymentMethod: 'Pay By Account',
  modelManufacturer: '',
  subCategory: {} as any,
  categoryListName: '',
  itemsInCart: {} as any
};

const AnalyticsReducer = (
  state = initialState,
  {
    type,
    payload,
    items,
    event,
    rmaNumber,
    returnOption
  }: {
    type: string;
    payload: any;
    items: any[];
    event: string;
    rmaNumber: string;
    returnOption: string;
  }
) => {
  let dataLayerObject = {};
  window['dataLayer'] = window['dataLayer'] || [];
  switch (type) {
    case types.PRODUCT_IMPRESSIONS:
      dataLayerObject = transformers.productImpressionTransformer(
        payload,
        type
      );
      window['dataLayer'].push({ ecommerce: undefined });
      window['dataLayer'].push(dataLayerObject);
      return { ...state };
    case types.PRODUCT_CLICK:
      dataLayerObject = transformers.productClickTransformer(payload, type);
      window['dataLayer'].push(dataLayerObject);
      localStorage.setItem('listName', payload.list);
      return { ...state };
    case types.PRODUCT_DETAIL:
      dataLayerObject = transformers.productDetailTransformer(payload, type);
      window['dataLayer'].push(dataLayerObject);
      localStorage.setItem('listName', '');
      return { ...state };
    case types.SHOP_BY_CATEGORY:
      const subCategory = payload.subcategories.find(
        (subCat: any) => subCat.id.toString() === payload.activeSubcategory.id
      );
      const data = {
        products: payload.products,
        list: analyticsListNames.SHOP_BY_PREFIX + subCategory.category.name,
        listCriteria: subCategory.name
      };
      dataLayerObject = transformers.productImpressionTransformer(
        data,
        types.PRODUCT_IMPRESSIONS
      );
      window['dataLayer'].push(dataLayerObject);
      return { ...state, subCategory, categoryListName: data.list };
    case types.SHOP_BY_CATEGORY_PAGEVIEW:
      window['dataLayer'].push({
        event: type,
        shopByCategoriesPath:
          state.subCategory.category.name + '/' + state.subCategory.name
      });
      return { ...state };
    case types.PLACE_ORDER_CONFIRMATION:
      dataLayerObject = transformers.measuringPurchasesTransformer(
        payload,
        types.MEASURING_PURCHASES
      );
      window['dataLayer'].push(dataLayerObject);
      return { ...state };
    case types.SEARCH_RESULT_IMPRESSIONS:
      dataLayerObject = transformers.searchResultProductImpressionTransformer(
        payload,
        types.PRODUCT_IMPRESSIONS
      );
      window['dataLayer'].push({ ecommerce: undefined });
      window['dataLayer'].push(dataLayerObject);
      localStorage.setItem('listName', payload.list);
      return { ...state, listName: payload.list };
    case types.SEARCH_RESULT_PRODUCT_CLICK:
      if (
        payload.product.productNumber ===
        window['dataLayer'][window['dataLayer'].length - 2]?.ecommerce?.click
          ?.products[0]?.name
      ) {
        return { ...state };
      }
      dataLayerObject = transformers.searchResultProductClickTransformer(
        payload,
        types.PRODUCT_CLICK
      );
      window['dataLayer'].push(dataLayerObject);
      localStorage.setItem('listName', payload.list);
      return { ...state };
    case types.PRODUCT_ADD_TO_CART:
      dataLayerObject = transformers.productAddToCart(payload, type);
      window['dataLayer'].push(dataLayerObject);
      return { ...state };
    case types.PRODUCT_ADD_SIMPLE_TO_CART:
      dataLayerObject = transformers.productAddToCart(
        payload,
        types.PRODUCT_ADD_TO_CART,
        '',
        analyticsListNames.LABEL_CART_PAGE_ADD_TO_CART
      );
      window['dataLayer'].push(dataLayerObject);
      return { ...state };
    case types.PRODUCT_ADD_TO_CART_FROM_FAVORITE_PAGE:
      dataLayerObject = transformers.productAddToCart(
        payload,
        types.PRODUCT_ADD_TO_CART,
        analyticsListNames.LIST_FAVORITES,
        analyticsListNames.LABEL_FAVORITES_ADD_TO_CART
      );
      window['dataLayer'].push(dataLayerObject);
      return { ...state };
    case types.PRODUCT_ADD_LIST_TO_CART_FROM_FAVORITE_PAGE:
      items.forEach(item => {
        const product = {
          productNumber: item.productNumber,
          manufacturer: item.manufacturer,
          manufacturerCode: item.manufacturerCode,
          price: item.unitPrice,
          quantity: item.quantity
        };
        dataLayerObject = transformers.productAddToCart(
          product,
          types.PRODUCT_ADD_TO_CART,
          analyticsListNames.LIST_FAVORITES,
          analyticsListNames.LABEL_FAVORITES_ADD_LIST_TO_CART
        );
        window['dataLayer'].push(dataLayerObject);
      });
      return { ...state };
    case types.PRODUCT_REMOVE_FROM_CART:
      const part = state.itemsInCart[payload];
      dataLayerObject = transformers.productRemoveFromCart(part, type);
      window['dataLayer'].push(dataLayerObject);
      return { ...state };
    case types.CHECKOUT_STEP:
      dataLayerObject = transformers.checkoutStep(payload, types.CHECKOUT);
      window['dataLayer'].push(dataLayerObject);
      return { ...state };
    case types.SEND_USER_DATA:
      window['dataLayer'].push({
        userId: payload.accountId,
        superUserId:
          payload.specialUser === undefined ? '' : payload.specialUser
      });
      return { ...state };
    case types.SEND_MODEL_PRODUCT_IMPRESSION:
      dataLayerObject = transformers.modelProductImpression(
        payload,
        type,
        state
      );
      return { ...state, ...dataLayerObject };
    case types.STORE_MODEL_DIAGRAM_PRODUCT_DATA:
      dataLayerObject = transformers.modelProductImpression(
        payload,
        type,
        state
      );
      return { ...state, ...dataLayerObject };
    case types.SEND_MODEL_DIAGRAM_PRODUCT_IMPRESSION:
      dataLayerObject = transformers.modelProductImpression(
        payload,
        type,
        state
      );
      return { ...state, ...dataLayerObject };
    case types.MODEL_DIAGRAM_PRODUCT_CLICK:
      payload.list = state.listName;
      dataLayerObject = transformers.productClickTransformer(
        payload,
        types.PRODUCT_CLICK
      );
      window['dataLayer'].push(dataLayerObject);
      localStorage.setItem('listName', payload.list);
      return { ...state };
    case types.GET_PAYMENT_METHOD_CHECKOUT:
      return { ...state, paymentMethod: paymentMethodMap[payload] };
    case types.PRODUCT_RETURNS:
      dataLayerObject = transformers.productReturns(payload, type);
      window['dataLayer'].push(dataLayerObject);
      return { ...state };
    case types.SELECTED_MODEL_INFORMATION:
      return { ...state, modelManufacturer: payload.manufacturer };
    case types.PRODUCT_UPLOAD_FILE_ADD_TO_CART:
      dataLayerObject = transformers.productAddToCart(
        payload,
        types.PRODUCT_ADD_TO_CART,
        analyticsListNames.UPLOAD_FILE
      );
      window['dataLayer'].push(dataLayerObject);
      return { ...state };
    case types.CATEGORIES_PRODUCT_CLICK:
      payload.list = state.categoryListName;
      dataLayerObject = transformers.productClickTransformer(
        payload,
        types.PRODUCT_CLICK
      );
      window['dataLayer'].push(dataLayerObject);
      localStorage.setItem('listName', payload.list);
      return { ...state, categoryListName: '' };
    case types.RMA_RETURNS_INFORMATION:
      dataLayerObject = transformers.rmaReturns(
        payload,
        event,
        rmaNumber,
        returnOption
      );
      window['dataLayer'].push(dataLayerObject);
      return { ...state };
    case types.GET_ITEMS_IN_CART_INFO:
      return { ...state, itemsInCart: { ...payload.items } };
    case types.UPDATE_CART_ITEM_QTY:
      const dl = {
        event: type,
        cartops: {
          item: {
            updateQuantity: {
              part: payload.item.productNumber,
              quantity: Number(payload.qty) - payload.item.quantity
            }
          }
        }
      };
      window['dataLayer'].push(dl);
      return { ...state };
    case types.CLEAR_ALL_ITEMS_FROM_CART:
      for (const [partId, partValue] of Object.entries(state.itemsInCart)) {
        dataLayerObject = transformers.productRemoveFromCart(
          partValue,
          types.PRODUCT_REMOVE_FROM_CART
        );
        window['dataLayer'].push(dataLayerObject);
      }
      return { ...state };
    default:
      return state;
  }
};

export default AnalyticsReducer;
